import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./context/AuthContextProvider";
import MiniMaxHeader from "./components/MiniMaxHeader";
import UnAuth from "./pages/auth/UnAuth";

const PROTECTED_PREFIXES = [
  "/",
  "/dashboard",
  "/ecg-reports",
  "/test-collections",
  "/new-test-collection",
  "/editcollectiontasks",
  "/collectingagents",
  "/clients",
  "/settings",
  "/patients",
  "/add-member",
  "/add-centre",
  "/help-center",
  "/onlineconsultation",
  "/cases",
  "/interpretation",
  "/unauth",
  "/onboarding",
  "/facilities",
  "/manage-facilities",
];

export const RequireAuth = ({
  children,
  role = [],
  permission = "",
  header = "yes",
  gaurd_type = "component",
}) => {
  const location = useLocation();
  const { is_login, user } = useContext(AuthContext);
  const doLater = JSON.parse(localStorage.getItem("spandan_do_later"));

  /* -------------------- ALLOW UNKNOWN ROUTES (404) -------------------- */
  const isProtectedRoute = PROTECTED_PREFIXES.some(
    (prefix) =>
      location.pathname === prefix ||
      location.pathname.startsWith(prefix)
  );

  //  Let React Router handle 404
  if (!isProtectedRoute) {
    return children;
  }

  const stage = Number(user?.stage || 0);

  if (stage !== 0 && !location.pathname.startsWith("/onboarding")) {
    return <Navigate to={`/onboarding/${stage}`} replace />;
  }
  /* -------------------- LOGIN -------------------- */
  if (!is_login) {
    return <Navigate to="/loginpassword" replace />;
  }
 

  /* -------------------- ROOT (/) -------------------- */
  // if (location.pathname === "/") {
  //   if (doLater === false) {
  //     return <Navigate to="/onboarding/6" replace />;
  //   }
  //   return <Navigate to="/dashboard" replace />;
  // }
  if (location.pathname === "/") {
    if (doLater === false && !isProtectedRoute) {
      return <Navigate to="/onboarding/6" replace />;
    }

    else if ((doLater === false || doLater === true && !isProtectedRoute) || isProtectedRoute) {
      return <Navigate to="/dashboard" replace />;
    }
    else {
      return <Navigate to="/404" replace />;
    }


  }


  /* -------------------- ONBOARDING GUARD -------------------- */
  if (
    doLater === false &&
    location.pathname.startsWith("/dashboard")
  ) {
    return <Navigate to="/onboarding/6" replace />;
  }


  /* -------------------- ROLE CHECK -------------------- */
  if (role.length && !role.includes(user?.userType)) {
    return gaurd_type === "component" ? null : (
      <>
        <MiniMaxHeader />
        <UnAuth />
      </>
    );
  }

  /* -------------------- PERMISSION CHECK -------------------- */
  if (user?.userType !== "b2b" && permission) {
    const hasPermission = Object.values(user?.permissions || {}).some(
      (group) => group?.[permission] === true
    );

    if (!hasPermission) {
      return gaurd_type === "component" ? null : (
        <>
          <MiniMaxHeader />
          <UnAuth />
        </>
      );
    }
  }

  /* -------------------- RENDER -------------------- */
  if (gaurd_type === "component") {
    return children;
  }

  return (
    <>
      {header === "yes" && <MiniMaxHeader />}
      {children}
    </>
  );
};
